import React from 'react';

export default function LoadingSpinner({ overlay, message = 'Yükleniyor...' }) {
  return (
    <div
      className={`d-flex flex-column align-items-center justify-content-center gap-3${overlay ? ' position-fixed top-0 start-0 w-100 h-100' : ' p-5'}`}
      style={overlay ? { zIndex: 9999, background: 'rgba(240,250,251,.85)', backdropFilter: 'blur(6px)' } : {}}
    >
      <div style={{ position: 'relative', width: 48, height: 48 }}>
        <div style={{
          position: 'absolute', inset: 0, borderRadius: '50%',
          border: '3px solid rgba(14,165,233,.15)'
        }} />
        <div style={{
          position: 'absolute', inset: 0, borderRadius: '50%',
          border: '3px solid transparent',
          borderTopColor: '#0ea5e9',
          borderRightColor: '#10b981',
          animation: 'spin .75s linear infinite'
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
      {message && (
        <span style={{ fontFamily: 'Plus Jakarta Sans,sans-serif', fontSize: '.82rem', fontWeight: 600, color: '#64748b' }}>
          {message}
        </span>
      )}
    </div>
  );
}
